var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/service/ADionApiService.ts
import qs2 from "qs";

// src/transport/ADionHTTPTransport.ts
import qs from "qs";

// src/transport/DionCoreHTTPTransport.ts
import { Mutex } from "async-mutex";

// src/transport/UpdateTokenStrategy/AUpdateTokenStrategy.ts
var AUpdateTokenStrategy = class {
  updateTokenAction() {
    return __async(this, null, function* () {
      throw new Error(`Update token strategy is not implemented`);
    });
  }
};

// src/transport/UpdateTokenStrategy/DefaultUpdateTokenStrategy.ts
var DefaultUpdateTokenStrategy = class extends AUpdateTokenStrategy {
};

// src/transport/UpdateTokenStrategy/DionUpdateTokenStrategy.ts
var DionUpdateTokenStrategy = class extends AUpdateTokenStrategy {
  constructor(getAuthUrl, expiredTokenCallback, setTokenCallback) {
    super();
    __publicField(this, "getAuthUrl", () => "");
    __publicField(this, "expiredTokenCallback");
    __publicField(this, "setTokenCallback");
    this.getAuthUrl = getAuthUrl;
    this.expiredTokenCallback = expiredTokenCallback;
    this.setTokenCallback = setTokenCallback;
  }
  updateTokenAction() {
    return __async(this, null, function* () {
      const refreshResponse = yield fetch(`${this.getAuthUrl()}/auth/refresh/web`, {
        method: "POST",
        credentials: "include"
      });
      if (!refreshResponse.ok) {
        this.expiredTokenCallback();
        throw new Error(`Error while request to /auth/refresh/web with status ${refreshResponse.status}`);
      } else {
        const refreshResult = yield refreshResponse.json();
        this.setTokenCallback(refreshResult.access_token);
      }
    });
  }
};

// src/transport/UpdateTokenStrategy/SIPUpdateTokenStrategy.ts
var SIPUpdateTokenStrategy = class extends AUpdateTokenStrategy {
  constructor(getAuthUrl, expiredTokenCallback, setTokenCallback) {
    super();
    __publicField(this, "getAuthUrl", () => "");
    __publicField(this, "expiredTokenCallback");
    __publicField(this, "setTokenCallback");
    this.getAuthUrl = getAuthUrl;
    this.expiredTokenCallback = expiredTokenCallback;
    this.setTokenCallback = setTokenCallback;
  }
  updateTokenAction() {
    return __async(this, null, function* () {
      const refreshResponse = yield fetch(`${this.getAuthUrl()}/token/web`, {
        method: "POST",
        credentials: "include"
      });
      if (!refreshResponse.ok) {
        this.expiredTokenCallback();
        throw new Error(`Error while request to /token/web with status ${refreshResponse.status}`);
      } else {
        const refreshResult = yield refreshResponse.json();
        this.setTokenCallback(refreshResult.access_token);
      }
    });
  }
};

// src/transport/UpdateTokenStrategy/getUpdateTokenStrategy.ts
var getUpdateTokenStrategy = (instance) => {
  switch (instance) {
    case "dion": {
      return (url, executeExpiredTokenCallback, setToken) => new DionUpdateTokenStrategy(url, executeExpiredTokenCallback, setToken);
    }
    case "sip": {
      return (url, executeExpiredTokenCallback, setToken) => new SIPUpdateTokenStrategy(url, executeExpiredTokenCallback, setToken);
    }
    default: {
      return () => new DefaultUpdateTokenStrategy();
    }
  }
};

// src/transport/DionCoreHTTPTransport.ts
var _DionCoreHTTPTransport = class _DionCoreHTTPTransport {
  constructor(updateTokenStrategy) {
    __publicField(this, "mutex");
    __publicField(this, "token", "");
    __publicField(this, "expiredTokenCallback", null);
    __publicField(this, "refreshTokenCallback", null);
    __publicField(this, "updateTokenStrategy");
    this.updateTokenStrategy = updateTokenStrategy;
    this.mutex = new Mutex();
  }
  isTokenExists() {
    return Boolean(this.token);
  }
  updateToken() {
    return __async(this, null, function* () {
      yield this.updateTokenStrategy.updateTokenAction();
    });
  }
  innerFetch(request) {
    return __async(this, null, function* () {
      const patchedRequest = request.clone();
      if (!patchedRequest.headers.get("Authorization") && this.isTokenExists()) {
        patchedRequest.headers.set("Authorization", `Bearer ${this.token}`);
      }
      return fetch(patchedRequest);
    });
  }
  executeRefreshTokenCallback() {
    if (this.refreshTokenCallback) {
      const token = this.token || "";
      this.refreshTokenCallback(token);
    }
  }
  static getInstance(instanceType) {
    if (!_DionCoreHTTPTransport.instances[instanceType]) {
      const defaultUpdateTokenStrategy = new DefaultUpdateTokenStrategy();
      _DionCoreHTTPTransport.instances[instanceType] = new _DionCoreHTTPTransport(defaultUpdateTokenStrategy);
    }
    return _DionCoreHTTPTransport.instances[instanceType];
  }
  setUpdateTokenStrategy(updateTokenStrategy) {
    this.updateTokenStrategy = updateTokenStrategy;
  }
  executeExpiredTokenCallback() {
    if (this.expiredTokenCallback) {
      this.expiredTokenCallback();
    }
  }
  getToken() {
    return this.token;
  }
  setToken(token) {
    this.token = token;
    this.executeRefreshTokenCallback();
  }
  setExpiredTokenCallback(expiredTokenCallback) {
    this.expiredTokenCallback = expiredTokenCallback;
  }
  setRefreshTokenCallback(refreshTokenCallback) {
    this.refreshTokenCallback = refreshTokenCallback;
  }
  requestWithoutAuthCheck(request) {
    return __async(this, null, function* () {
      if (this.mutex.isLocked()) {
        yield this.mutex.waitForUnlock();
      }
      return this.innerFetch(request);
    });
  }
  requestWithAuthCheck(request) {
    return __async(this, null, function* () {
      yield this.mutex.waitForUnlock();
      if (!this.token) {
        if (this.mutex.isLocked()) {
          yield this.mutex.waitForUnlock();
        } else {
          const releaseToken = yield this.mutex.acquire();
          try {
            yield this.updateToken();
          } finally {
            releaseToken();
          }
        }
      }
      const response = yield this.innerFetch(request);
      if (!response.ok && response.status === 401) {
        if (this.mutex.isLocked()) {
          yield this.mutex.waitForUnlock();
          return this.innerFetch(request);
        } else {
          const releaseFlow = yield this.mutex.acquire();
          try {
            yield this.updateToken();
            return this.innerFetch(request);
          } finally {
            releaseFlow();
          }
        }
      }
      return response;
    });
  }
};
__publicField(_DionCoreHTTPTransport, "instances", {});
var DionCoreHTTPTransport = _DionCoreHTTPTransport;

// src/transport/utils/getTrackingHeaders.ts
import { isElectron, parseUserAgent } from "react-device-detect";
import { uuid } from "uuidv4";
var getTrackingHeaders = () => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const userInfo = parseUserAgent((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userAgent);
  const headers = {
    "D-Platform": isElectron ? "desktop" : "web",
    "D-OS": (_b = userInfo == null ? void 0 : userInfo.os) == null ? void 0 : _b.name,
    "D-OS-Version": (_c = userInfo == null ? void 0 : userInfo.os) == null ? void 0 : _c.version,
    "D-Device-Type": prepareDeviceType((_d = userInfo == null ? void 0 : userInfo.device) == null ? void 0 : _d.type),
    "D-Browser-Type": (_e = userInfo == null ? void 0 : userInfo.browser) == null ? void 0 : _e.name,
    "D-Browser-Version": (_f = userInfo == null ? void 0 : userInfo.browser) == null ? void 0 : _f.version,
    "D-Device-Brand": (_g = userInfo == null ? void 0 : userInfo.device) == null ? void 0 : _g.vendor,
    "D-Device-Model": (_h = userInfo == null ? void 0 : userInfo.device) == null ? void 0 : _h.model,
    "D-Screen-Height": `${window == null ? void 0 : window.innerHeight}`,
    "D-Screen-Width": `${window == null ? void 0 : window.innerWidth}`,
    "X-Request-ID": uuid()
  };
  return Object.keys(headers).reduce((acc, cur) => {
    if (headers[cur]) {
      acc[cur] = headers[cur];
    }
    return acc;
  }, {});
};
var prepareDeviceType = (type) => {
  switch (type) {
    case "wearable":
    case "mobile":
      return "mobile";
    case "tablet":
      return "tablet";
    default:
      return "pc";
  }
};

// src/transport/utils/joinUrls.ts
var withoutTrailingSlash = (url) => url.replace(/\/$/, "");
var withoutLeadingSlash = (url) => url.replace(/^\//, "");
var isAbsoluteUrl = (url) => new RegExp(`(^|:)//`).test(url);
function joinUrls(base, url) {
  if (!base) {
    return url;
  }
  if (!url) {
    return base;
  }
  if (isAbsoluteUrl(url)) {
    return url;
  }
  const delimiter = base.endsWith("/") || !url.startsWith("?") ? "/" : "";
  base = withoutTrailingSlash(base);
  url = withoutLeadingSlash(url);
  return `${base}${delimiter}${url}`;
}

// src/transport/ADionHTTPTransport.ts
import { useCallback, useEffect, useRef, useState } from "react";

// src/utils/removeDublicateHeaderValuesFromString.ts
import uniqWith from "lodash.uniqwith";
var headerValueComparator = (a, b) => a.toLowerCase() === b.toLowerCase();
var removeDublicateHeaderValuesFromString = (str) => {
  const headerValueList = str.split(",").map((header) => header.trim());
  const uniqHeaderValueList = uniqWith(headerValueList, headerValueComparator);
  return uniqHeaderValueList.join(", ");
};

// src/transport/ADionHTTPTransport.ts
var ADionHTTPTransport = class {
  constructor(params) {
    __publicField(this, "transport");
    __publicField(this, "instanceType", "dion");
    __publicField(this, "getBaseUrl", () => "");
    __publicField(this, "additionalHeaders");
    __publicField(this, "enableTrackingHeaders");
    __publicField(this, "globalCredentials");
    __publicField(this, "getFileBlobUrlHook", () => {
      return (src, options) => {
        const [objectURL, setObjectURL] = useState();
        const [isLoading, setIsLoading] = useState(true);
        const [isError, setIsError] = useState(false);
        const controllerRef = useRef(null);
        const isMounted = useRef(true);
        const fetchBlob = useCallback(() => __async(this, null, function* () {
          var _a;
          if (!src) {
            setObjectURL(void 0);
            setIsLoading(false);
            setIsError(false);
            return;
          }
          (_a = controllerRef.current) == null ? void 0 : _a.abort();
          const controller = new AbortController();
          controllerRef.current = controller;
          try {
            setIsLoading(true);
            const response = yield this.request(src, __spreadProps(__spreadValues({}, options), { signal: controller.signal }));
            if (!response.ok)
              throw new Error(`HTTP error! status: ${response.status}`);
            const blob = yield response.blob();
            const newUrl = URL.createObjectURL(blob);
            setObjectURL(newUrl);
            setIsError(false);
            setIsLoading(false);
          } catch (error) {
            if (error instanceof Error && error.name !== "AbortError" && isMounted.current) {
              setObjectURL(void 0);
            }
            setIsLoading(false);
            setIsError(true);
          }
        }), [src, options]);
        useEffect(() => {
          const controller = controllerRef.current;
          return () => {
            controller == null ? void 0 : controller.abort();
            isMounted.current = false;
            if (objectURL)
              URL.revokeObjectURL(objectURL);
          };
        }, [objectURL]);
        useEffect(() => {
          fetchBlob();
        }, [fetchBlob]);
        return {
          objectURL,
          isLoading,
          isError
        };
      };
    });
    var _a, _b;
    this.setInstanceType(params);
    this.getBaseUrl = params.getBaseUrl;
    this.transport = DionCoreHTTPTransport.getInstance(this.instanceType);
    this.enableTrackingHeaders = (_a = params.enableTrackingHeaders) != null ? _a : true;
    this.globalCredentials = (_b = params.globalCredentials) != null ? _b : "same-origin";
    if (params.additionalHeaders) {
      this.additionalHeaders = params.additionalHeaders;
    }
  }
  innerRequest(input, init) {
    var _b;
    let request;
    const trackingHeaders = this.enableTrackingHeaders ? getTrackingHeaders() : {};
    const options = __spreadProps(__spreadValues({
      credentials: this.globalCredentials
    }, init), {
      headers: __spreadValues(__spreadValues(__spreadValues({}, init == null ? void 0 : init.headers), this.additionalHeaders), trackingHeaders)
    });
    if (typeof input === "string") {
      const baseUrl = this.getBaseUrl();
      const url = joinUrls(baseUrl, input);
      request = new Request(url, options);
    }
    if (input instanceof Request) {
      Object.keys(options.headers).forEach((header) => {
        input.headers.append(header, options.headers[header]);
      });
      for (const pair of input.headers.entries()) {
        pair[1] = removeDublicateHeaderValuesFromString(pair[1]);
        input.headers.set(pair[0], pair[1]);
      }
      const _a = options, { headers } = _a, optionsWithoutHeaders = __objRest(_a, ["headers"]);
      request = new Request(input, optionsWithoutHeaders);
    }
    return ((_b = init == null ? void 0 : init.checkToken) != null ? _b : true) ? this.transport.requestWithAuthCheck(request) : this.transport.requestWithoutAuthCheck(request);
  }
  setInstanceType(params) {
    var _a;
    this.instanceType = (_a = params.instanceType) != null ? _a : "dion";
  }
  // @ts-ignore
  request(input, init) {
    return this.innerRequest(input, init);
  }
  // @ts-ignore
  requestRTKQ(fetchBaseQuery) {
    const getRawFetchBaseQuery = (extraOptions) => fetchBaseQuery({
      baseUrl: this.getBaseUrl(),
      // @ts-ignore
      fetchFn: (request, init) => {
        return this.innerRequest.call(this, request, __spreadValues(__spreadValues({}, init), extraOptions));
      },
      paramsSerializer: (params) => {
        return qs.stringify(
          params,
          {
            arrayFormat: "repeat"
          }
        );
      }
    });
    return (args, api, extraOptions) => {
      const urlEnd = typeof args === "string" ? args : args.url;
      const adjustedUrl = `${this.getBaseUrl()}${urlEnd}`;
      const adjustedArgs = typeof args === "string" ? adjustedUrl : __spreadProps(__spreadValues({}, args), { url: adjustedUrl });
      return getRawFetchBaseQuery(extraOptions)(adjustedArgs, api, extraOptions);
    };
  }
  // @ts-ignore
  getUppyXHROptions(xhrPluginOptions) {
    return __spreadProps(__spreadValues({}, xhrPluginOptions), {
      endpoint: `${this.getBaseUrl()}${xhrPluginOptions.endpoint}`,
      onBeforeRequest: (xhr) => __async(this, null, function* () {
        if (xhrPluginOptions.onBeforeRequest) {
          yield xhrPluginOptions.onBeforeRequest(xhr);
        }
        xhr.setRequestHeader("Authorization", `Bearer ${this.getToken()}`);
      }),
      onAfterResponse: (xhr) => __async(this, null, function* () {
        if (xhrPluginOptions.onAfterResponse) {
          yield xhrPluginOptions.onAfterResponse(xhr);
        }
        if (xhr.status === 401) {
          yield this.forcedUpdateToken();
        }
      })
    });
  }
  getToken() {
    return this.transport.getToken();
  }
  // TODO: должен быть только у host-транспорта
  setToken(token) {
    this.transport.setToken(token);
  }
  // TODO: метод принудительного обновления токена
  forcedUpdateToken() {
    return Promise.reject();
  }
};

// src/transport/DionHTTPTransport.ts
var DionHTTPTransport = class extends ADionHTTPTransport {
};

// src/transport/DionHostHTTPTransport.ts
var DionHostHTTPTransport = class extends ADionHTTPTransport {
  setUpdateTokenStrategy(params) {
    const updateTokenStrategy = getUpdateTokenStrategy(this.instanceType)(
      params.getAuthUrl,
      this.transport.executeExpiredTokenCallback.bind(this.transport),
      this.transport.setToken.bind(this.transport)
    );
    this.transport.setUpdateTokenStrategy(updateTokenStrategy);
  }
  constructor(params) {
    super(params);
    if (params.expiredTokenCallback) {
      this.transport.setExpiredTokenCallback(params.expiredTokenCallback);
    }
    if (params.refreshTokenCallback) {
      this.transport.setRefreshTokenCallback(params.refreshTokenCallback);
    }
    this.setUpdateTokenStrategy(params);
  }
};

// src/service/ADionApiService.ts
var ADionApiService = class {
  constructor(params) {
    __publicField(this, "transport");
    this.transport = new DionHTTPTransport(params);
  }
  requestWithValidation(input, init) {
    return __async(this, null, function* () {
      var _a;
      let response;
      switch ((_a = init == null ? void 0 : init.headers) == null ? void 0 : _a["Content-Type"]) {
        case "multipart/form-data":
          delete init.headers["Content-Type"];
          response = yield this.transport.request(input, init);
          break;
        case "application-json":
        default:
          response = yield this.transport.request(input, __spreadProps(__spreadValues({}, init), {
            headers: __spreadValues({
              "Content-Type": "application/json; charset=utf-8"
            }, init == null ? void 0 : init.headers),
            // @ts-ignore
            body: JSON.stringify(init.body)
          }));
          break;
      }
      if (!response.ok) {
        throw response;
      }
      return response;
    });
  }
  get(path, query, params, queryParamArrayFormat = "repeat") {
    const queryParams = query ? "?" + qs2.stringify(query, { arrayFormat: queryParamArrayFormat }) : "";
    const pathWithQueryParams = path + queryParams;
    return this.requestWithValidation(pathWithQueryParams, __spreadValues({
      method: "GET"
    }, params));
  }
  post(path, payload, params) {
    return this.requestWithValidation(path, __spreadValues({
      body: payload,
      method: "POST"
    }, params));
  }
  put(path, payload, params) {
    return this.requestWithValidation(path, __spreadValues({
      body: payload,
      method: "PUT"
    }, params));
  }
  patch(path, payload, params) {
    return this.requestWithValidation(path, __spreadValues({
      body: payload,
      method: "PATCH"
    }, params));
  }
  delete(path, payload, params) {
    return this.requestWithValidation(path, __spreadValues({
      body: payload,
      method: "DELETE"
    }, params));
  }
  setGlobalTransportToken(token) {
    this.transport.setToken(token);
  }
  getToken() {
    return this.transport.getToken();
  }
};
export {
  ADionApiService,
  DionHTTPTransport,
  DionHostHTTPTransport
};

//# sourceMappingURL=index.js.map